document.addEventListener("DOMContentLoaded", function () {

  // Submenu accordion
  document.querySelectorAll(".submenu-toggle").forEach(toggle => {
    toggle.addEventListener("click", function () {
      const parent = this.closest(".menu-item");
      parent.classList.toggle("open");
    });
  });
});